export default "__VITE_ASSET__FUxmMf9___"